import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the customIndicators state domain
 */

const selectCustomIndicatorsDomain = (state) =>
  state.get("customIndicators", initialState)

/**
 * Other specific selectors
 */

/**
 * Default selector used by CustomIndicators
 */

const makeSelectCustomIndicators = () =>
  createSelector(selectCustomIndicatorsDomain, (substate) => substate.toJS())

export const makeSelectIsLoading = () =>
  createSelector(selectCustomIndicatorsDomain, (state) =>
    state.get("isLoading")
  )

export const makeSelectSurveyTypes = () =>
  createSelector(selectCustomIndicatorsDomain, (state) =>
    state.get("surveyTypes")
  )

export default makeSelectCustomIndicators
export { selectCustomIndicatorsDomain }
